import { logFeature } from '@office-start/telemetry-service';
import { getPageTimings, MosHubScenarios, } from '@office-start/ttvr-performance-service';
/**
 * Used to log params received from Hub SDK
 * @param params object type AppHostInstrumentationParams
 */
export const logMosHubFeature = (params) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    logFeature({
        featureName: "MOSHub" /* KnownFeatureNames.MOSHub */,
        eventName: "MOS_Hub_SDK_Request" /* KnownFeatureInstrumentationEvents.MOSHubSDK */,
        params: {
            AppHostSessionId: params.appHostSessionId,
            AppId: params.appId,
            Error: (_a = params.error) !== null && _a !== void 0 ? _a : '',
            ClientTimeStamp: (_b = params.clientTimestamp) !== null && _b !== void 0 ? _b : 0,
            FrameContext: params.frameContext,
            MessageDelayMs: (_c = params.messageDelayMs) !== null && _c !== void 0 ? _c : 0,
            MOSHubScenarioName: params.scenarioName,
            IsTileChange: (_d = params.isTileChange) !== null && _d !== void 0 ? _d : false,
            AppUrl: (_e = params.appUrl) !== null && _e !== void 0 ? _e : '',
            PagePrefetchTime: (_f = params.pagePrefetchTime) !== null && _f !== void 0 ? _f : 0,
            PageTimeLoadSinceDocumentRenderStarts: (_g = params.pageTimeLoadSinceDocumentRenderStarts) !== null && _g !== void 0 ? _g : 0,
            PagePrefetchRedirectionCount: (_h = params.pagePrefetchRedirectionCount) !== null && _h !== void 0 ? _h : 0,
            IsStandaloneApp: (_j = params.isStandaloneCopilotApp) !== null && _j !== void 0 ? _j : false,
            ResourceDeliveryType: (_k = params.resourceDeliveryType) !== null && _k !== void 0 ? _k : '',
        },
        area: 'MOSAppHost',
        subArea: params.scenarioName,
    });
    // Store the scenarios with delay in ms for PAS tool to consume
    const pageTimings = getPageTimings();
    if (!pageTimings[params.scenarioName] &&
        MosHubScenarios.includes(params.scenarioName)) {
        pageTimings[params.scenarioName] = (_l = params.messageDelayMs) !== null && _l !== void 0 ? _l : 0;
    }
};
//# sourceMappingURL=logMosHubFeature.js.map